module.exports = __webpack_public_path__ + "img/file-x.c9bea70c.svg";